import { render } from "./Payment.vue?vue&type=template&id=115a8db6"
import script from "./Payment.vue?vue&type=script&setup=true&lang=js"
export * from "./Payment.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Public/Proposal/Payment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "115a8db6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('115a8db6', __exports__)) {
    api.reload('115a8db6', __exports__)
  }
  
  module.hot.accept("./Payment.vue?vue&type=template&id=115a8db6", () => {
    api.rerender('115a8db6', render)
  })

}


export default __exports__